import React, { useEffect, useState } from "react";
import { getListPublicity } from "../../interpreter/publicity";
import { FaSearch, FaTimes } from "react-icons/fa";

const PublicityFilter = ({ filters, onFiltersChange, onClear }) => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        let cancelled = false;

        getListPublicity()
            .then((data) => {
                if (!cancelled) setCategories(Array.isArray(data) ? data : []);
            })
            .catch(() => {
                if (!cancelled) setCategories([]);
            });

        return () => {
            cancelled = true;
        };
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        onFiltersChange({ ...filters, [name]: value });
    };

    const hasActiveFilters = Boolean(filters.commercialName || filters.categoryId);

    return (
        <div className="bg-white p-4 shadow-md rounded-lg mb-4">
            <h3 className="text-lg font-semibold mb-3 text-left">Buscar publicidades</h3>

            <div className="flex flex-col md:flex-row gap-3">
                <div className="relative flex-1">
                    <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={14} />
                    <input
                        type="text"
                        name="commercialName"
                        placeholder="Nombre comercial o enlace"
                        value={filters.commercialName}
                        onChange={handleChange}
                        className="border border-slate-200 pl-9 pr-3 py-2 rounded-lg w-full h-10"
                    />
                </div>

                <select
                    name="categoryId"
                    value={filters.categoryId}
                    onChange={handleChange}
                    className="border border-slate-200 p-2 rounded-lg w-full md:w-64 h-10 bg-white"
                >
                    <option value="">Todas las categorías</option>
                    {categories.map((cat) => (
                        <option key={cat.id} value={String(cat.id)}>
                            {cat.description}
                        </option>
                    ))}
                </select>

                {hasActiveFilters ? (
                    <button
                        type="button"
                        onClick={onClear}
                        className="h-10 px-3 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700 flex items-center justify-center gap-2"
                    >
                        <FaTimes size={12} />
                        Limpiar
                    </button>
                ) : null}
            </div>
        </div>
    );
};

export default PublicityFilter;
